import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://3xnvbp3cbqxilxcynksgzltaru0vtmll.lambda-url.ap-south-1.on.aws';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'accept': 'application/json',
  },
});

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

apiClient.interceptors.request.use((config) => {
  const token = getCookie('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const editEvaluators = async (data) => {
  const response = await apiClient.post('/api/v2/evaluation-group/edit-evaluators', data);
  return response.data;
};

export const getEvaluationGroup = async (id) => {
  const response = await apiClient.get(`/api/v2/evaluation-group/find-one-by-id/${id}`);
  return response.data;
};

export const getWorkflowTemplate = async (templateId) => {
  const response = await apiClient.get(`/api/v2/workflow-template/${templateId}`);
  return response.data;
};

export default apiClient;
